import { render, staticRenderFns } from "./Row.vue?vue&type=template&id=72fbda3f&scoped=true&"
import script from "./Row.vue?vue&type=script&lang=js&"
export * from "./Row.vue?vue&type=script&lang=js&"
import style0 from "./Row.vue?vue&type=style&index=0&id=72fbda3f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72fbda3f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VTooltip})
